package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
data class AttendanceThresholdCreateRequest(
    @SerialName("attendance_level") val attendanceLevel: String,
    @SerialName("min_percentage") val minPercentage: Int,
    @SerialName("max_percentage") val maxPercentage: Int,
    @SerialName("display_order") val displayOrder: Int = 0
)

@Serializable
data class ExamGradeThresholdCreateRequest(
    @SerialName("performance_level") val performanceLevel: String,
    val grade: String,
    @SerialName("min_percentage") val minPercentage: Int,
    @SerialName("max_percentage") val maxPercentage: Int
)

@Serializable
data class SchoolHolidayCreateRequest(
    @SerialName("holiday_date") val holidayDate: String,
    @SerialName("holiday_name") val holidayName: String
)

@Serializable
data class SchoolFeatureConfigCreateRequest(
    @SerialName("feature_key") val featureKey: String,
    @SerialName("is_enabled") val isEnabled: Boolean = true,
    val settings: JsonObject? = null
)

@Serializable
data class SchoolConfigGeneralUpdateRequest(
    @SerialName("attendance_thresholds") val attendanceThresholds: List<AttendanceThresholdCreateRequest>,
    @SerialName("exam_grade_thresholds") val examGradeThresholds: List<ExamGradeThresholdCreateRequest>
)

@Serializable
data class SchoolConfigCalendarUpdateRequest(
    val holidays: List<SchoolHolidayCreateRequest>
)

@Serializable
data class SchoolConfigFeatureUpdateRequest(
    @SerialName("feature_configs") val featureConfigs: List<SchoolFeatureConfigCreateRequest>
)
